var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1CallReady(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2 20.3l-3-2.7L49.4 31l4.4 3.9A69.5 69.5 0 0147 44a88.9 88.9 0 01-8.2 8l-4.4-3.9-11.7 13.3 3 2.7a3.8 3.8 0 003.7.7h.1l.5-.3c6.1-2.8 14.9-9.8 21.1-16.9s12.1-16.7 14.1-23.1a.7.7 0 00.1-.5.1.1 0 00.1-.1 4 4 0 00-1.2-3.6zM43.6 20.6L25 36.9l-7.3-8.5 3.1-2.6 4.6 5.4 15.5-13.6 2.7 3z"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Call_ready.51130bd0.svg";
export { SvgH1CallReady as ReactComponent };